import {PodcastLinks as Links} from '../../Home/Podcast/Links'

const Podcasts = [
  {
    url: Links.spotify,
    value: 'Spotify',
  },
  {
    url: Links.apple,
    value: 'Apple Podcasts',
  },
  {
    url: Links.pocketCast,
    value: 'PocketCast',
  },
  {
    url: Links.google,
    value: 'Google Podcasts',
  },
  {
    url: Links.overcast,
    value: 'Overcast',
  },
  {
    url: Links.radioPublic,
    value: 'RadioPublic',
  },
];


export default Podcasts;